import store from './../index';
import { tasksListLoaded } from './../actions';

export default function loadTasksList() {
    return fetch('/tasksList.json')
        .then(res => res.json())
        .then(data => {
            window.localStorage.setItem('tasksList', JSON.stringify(data));
            store.dispatch(tasksListLoaded(data));
        })
        .catch(err => console.error('ERROR', err));
}